import { render, staticRenderFns } from "./FamilyPermittedFunctionEditTab.vue?vue&type=template&id=50b549e7&scoped=true&lang=pug"
import script from "./FamilyPermittedFunctionEditTab.vue?vue&type=script&lang=ts"
export * from "./FamilyPermittedFunctionEditTab.vue?vue&type=script&lang=ts"
import style0 from "./FamilyPermittedFunctionEditTab.vue?vue&type=style&index=0&id=50b549e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b549e7",
  null
  
)

export default component.exports